import firebase from 'firebase';

const config = {
  apiKey: 'AIzaSyClabk633x6M3r0_WPFOAXCdQoudUSyZAM',
  authDomain: 'debt-rainbow.firebaseapp.com',
  databaseURL: 'https://debt-rainbow.firebaseio.com',
  projectId: 'debt-rainbow',
  storageBucket: 'debt-rainbow.appspot.com',
  messagingSenderId: '427499348871',
};

firebase.initializeApp(config);

export const db = firebase.database().ref();
export default firebase;



// WEBPACK FOOTER //
// ./src/lib/firebase.js